export default __webpack_public_path__ + "static/media/National_Logo2.85d2a0a6.png";